

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Campaign, Nullable } from '@/app/shared/utilities/static-types';
import CampaignItemContent from '@userApp/shared/components/CampaignItemContent.vue';
import ClickableListItem from '@userApp/shared/components/ClickableListItem.vue';
import { SYSTEM_STATUS } from '@/app/shared/utilities/object-factory';
import CampaignInfoPopup from '@/app/screens/App/screens/Campaigns/shared/components/CampaignInfoPopup.vue';
import { AdminRoutes } from '@/app/shared/utilities/routes-names';
import { FirebaseAppFirestore } from '@/app/shared/firebase/firebase-app';
import firebaseNames from '@/app/shared/utilities/firebase-names';
import namespace from '@/app/shared/store/namespace';

@Component({
  components: {
    CampaignItemContent,
    ClickableListItem,
    CampaignInfoPopup,
  },
})
export default class ClickableCampaignItem extends Vue {
  @Prop({ required: true }) public campaign!: Campaign;
  @Prop({ required: false, default: false }) public isCampaignOwner!: boolean;

  public selectedCampaign: Nullable<Campaign> = null;
  public advertiserReviewCampaignRoute = AdminRoutes.ADVERTISER_CAMPAIGN_REVIEW;

  public showCampaignMediaPopup(): void {
    this.selectedCampaign = this.campaign;
    (this.$refs.campaignMediaPopup as CampaignInfoPopup).open();
  }

  public reviewCampaign(): void {
    this.setCampaignRef();
    this.$router.push({ ...this.advertiserReviewCampaignRoute });
  }

  public handleClick() {
    if (this.campaign.STATUS.VAL === SYSTEM_STATUS.PENDING_PAYMENT.VAL) {
      return this.reviewCampaign();
    }
    return this.showCampaignMediaPopup();
  }

  private get campaignRef() {
    const { ADVERTISER_UID, ID } = this.campaign;
    return FirebaseAppFirestore
      .collection(firebaseNames.CAMPAIGNS.VAL)
      .doc(ADVERTISER_UID)
      .collection(firebaseNames.CAMPAIGNS.USER_CAMPAIGNS)
      .doc(ID);
  }

  private setCampaignRef() {
    this.$store.commit(
      `${namespace.CampaignModule}/setCurrentStoreCampaignRef`,
      this.campaignRef,
    );
  }
}
